import React from "react";
import { Route, Routes } from "react-router-dom";
import NowPlayingPage from "../pages/NowPlayingPage/index.tsx";
import MovieDetailsPage from "../pages/MovieDetailsPage/index.tsx";
import TvShowsPage from "../pages/TvShowsPage/index.tsx";
import TvDetailsPage from "../pages/TvDetailsPage/index.tsx";
import NotFound from "../pages/NotFound/index.tsx";
import MoviesPage from "../pages/MoviesPage/index.tsx";
import GenreDetailPage from "../pages/GenreDetailPage/index.tsx";
import GenreListPage from "../pages/GenreListPage/index.tsx";
import SearchPage from "../pages/SearchPage/index.tsx";
import DiscoverPage from "../pages/DiscoverPage/index.tsx";
import PeoplePage from "../pages/PeoplePage/index.tsx";
import PersonDetailPage from "../pages/PersonDetailPage/index.tsx";
import PrivacyPage from "../pages/PrivacyPage/index.tsx";

const LayoutRoutes: React.FC = () => {
  return (
    <>
      <Routes>
        <Route index element={<NowPlayingPage />}></Route>
        <Route
          path="/movie-details/:movieId"
          element={<MovieDetailsPage />}
        ></Route>
        <Route path="/genres/:type" element={<GenreListPage />} />
        <Route path="/genres/:mediaType/:genreId" element={<GenreDetailPage />} />
        <Route path="/movies" element={<MoviesPage />}></Route>
        <Route path="/shows" element={<TvShowsPage />}></Route>
        <Route path="/tv-details/:tvId" element={<TvDetailsPage />}></Route>
        <Route path="/search" element={<SearchPage />}></Route>
        <Route path="/discover" element={<DiscoverPage />}></Route>
        <Route path="/people" element={<PeoplePage />}></Route>
        <Route path="/person/:personId" element={<PersonDetailPage />}></Route>
        <Route path="/privacy" element={<PrivacyPage />}></Route>
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
    </>
  );
};

export default LayoutRoutes;
